import { Button } from 'semantic-ui-react';
import { CrecerFilters } from 'src/containers/crecer/crecerShared';
import { PageWrapper, StepCard, StepTitle, StepSubtitle } from './styles';

export default function FiltersStep({ inputs, currentEvent, onSelectChange, onContinue }) {
  return (
    <PageWrapper>
      <StepCard>
        <StepTitle>¿Qué asistencia quieres agregar?</StepTitle>
        <StepSubtitle>
          Elige el tipo (Crecer o Seminarios) y el paso o seminario correspondiente.
        </StepSubtitle>
        <div className="filters-section" style={{ marginBottom: 24 }}>
          <CrecerFilters inputs={inputs} onSelectChange={onSelectChange} />
        </div>
        <Button primary onClick={onContinue} disabled={!currentEvent}>
          Ver fechas de asistencia
        </Button>
      </StepCard>
    </PageWrapper>
  );
}
